import { render, staticRenderFns } from "./courseComponents.vue?vue&type=template&id=59ab0aaf&"
import script from "./courseComponents.vue?vue&type=script&lang=js&"
export * from "./courseComponents.vue?vue&type=script&lang=js&"
import style0 from "./courseComponents.vue?vue&type=style&index=0&id=59ab0aaf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports